import {
  InternalAdTrackingData,
  InternalAdTrackingDataParams,
} from "@shared/services/event_tracking/entities/ads/internal_ad_tracking_data";

interface SpotlightAdEntityParams extends InternalAdTrackingDataParams {
  product_line_ids: number[];
  custom_content_spotlight_id: number;
}

export class SpotlightAdEntity extends InternalAdTrackingData {
  placement_image_url: string;
  product_line_ids: number[];
  custom_content_spotlight_id: number;

  constructor(params: SpotlightAdEntityParams) {
    super(params);
    this.type = "spotlight_ad";
    this.entity_version = 2;
    this.product_line_ids = params.product_line_ids;
    this.custom_content_spotlight_id = params.custom_content_spotlight_id;
  }
}
